import { DatePicker } from 'components/shared/DatePicker/DatePicker';

import './date-picker-labelled.scss';

export type DatePickerLabelledProps = {
  id: string;
  label: string;
  allowWeekend?: boolean;
  defaultValues?: readonly (string | undefined | null)[];
  values?: readonly (string | undefined | null)[];
  className?: string;
  e2e?: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isInvalid?: boolean;
  isHighlighted?: boolean;
  maxDate?: string;
  minDate?: string;
  availableDates?: readonly string[];
  onChange: (selectedDate: string | null) => void;
  blackoutDates?: readonly string[];
};

export const DatePickerLabelled = ({
  id,
  label,
  className,
  onChange,
  values,
  defaultValues,
  e2e,
  isDisabled = false,
  isReadOnly = false,
  isInvalid = false,
  isHighlighted = false,
  availableDates,
  maxDate,
  minDate,
  allowWeekend,
  blackoutDates,
}: DatePickerLabelledProps) => {
  return (
    <div
      className={`date-picker-labelled-container input-group bg-lvl1 ${isHighlighted ? 'border-bottom border-info' : ''}`}
    >
      <div className="input-icon-start w-auto px-12px">
        <label id={id} className="text-secondary fs-5">
          {label}
        </label>
      </div>
      <DatePicker
        allowWeekend={allowWeekend}
        id={id}
        type="mono"
        data-e2e={e2e}
        labelledBy={id}
        className={`date-picker h-100 ${className}`}
        size="lg"
        isClearable={false}
        align="end"
        onChange={onChange}
        values={values}
        defaultValues={defaultValues}
        disabled={isDisabled}
        isReadOnly={isReadOnly}
        availableDates={availableDates}
        minDate={minDate}
        maxDate={maxDate}
        hasError={isInvalid}
        blackoutDates={blackoutDates}
      />
    </div>
  );
};
